import { Spin } from 'antd';
import React from 'react';
import { useGetUserContextQuery } from 'services/user-context/user-context-api';
import ErrorPage from 'ui/error-pages/error-page';

export interface IContextWrapper {
  children: JSX.Element;
}

const ContextWrapper = ({ children }: IContextWrapper) => {
  const { data, error, isLoading } = useGetUserContextQuery();

  if (error) {
    return <ErrorPage error={error} />;
  }

  if (isLoading) {
    return (
      <p style={{ margin: '24px' }}>
        <Spin />
      </p>
    );
  }

  if (data) {
    return children;
  }

  return null;
};

export default ContextWrapper;
